import { createReducer } from "redux-act";
import {
    clearFilteredLocationList,
    fetchCompanyListSuccess,
    fetchFilteredLocationListSuccess,
    setSurfaceDefaultsValidationConfirm,
    validateSurfaceDefaultsFailed,
    validateSurfaceDefaultsRequest,
    validateSurfaceDefaultsSuccess,
} from "./actions";

export const SURFACE_DEFAULTS_DATA_KEY = "SURFACE_DEFAULTS_DATA";
const initialState = {
    companyList: null,
    locationList: null,
    validationConfirmRequired: false,
    validationSucceeded: false,
};

export const surfaceDefaultsReducer = createReducer(
    {
        [clearFilteredLocationList]: (state) => ({
            ...state,
            filteredLocationList: [],
        }),
        [fetchCompanyListSuccess]: (state, { companyList }) => ({
            ...state,
            companyList,
        }),
        [fetchFilteredLocationListSuccess]: (state, { filteredLocationList }) => ({
            ...state,
            filteredLocationList,
        }),
        [setSurfaceDefaultsValidationConfirm]: (state, payload = false) => ({
            ...state,
            validationConfirmRequired: payload,
            validationSucceeded: payload ? state.validationSucceeded : false,
        }),
        [validateSurfaceDefaultsRequest]: (state) => ({
            ...state,
            validationConfirmRequired: false,
            validationSucceeded: false,
        }),
        [validateSurfaceDefaultsSuccess]: (state) => ({
            ...state,
            validationConfirmRequired: false,
            validationSucceeded: true,
        }),
        [validateSurfaceDefaultsFailed]: (state) => ({
            ...state,
            validationConfirmRequired: false,
            validationSucceeded: false,
        }),
    },
    initialState
);
